(() => {
  const minKey = 'joa_budget_min', maxKey = 'joa_budget_max';
  const number = value => value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? Math.round(Number(value) * 100) : null;
  class JoaBudgetFilter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-joa-budget-copy]').textContent);
      this.hidden = false;
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const min = this.querySelector(`[name="${minKey}"]`), max = this.querySelector(`[name="${maxKey}"]`);
        max.setCustomValidity('');
        if (number(min.value) !== null && number(max.value) !== null && number(min.value) > number(max.value)) {
          max.setCustomValidity(this.copy.invalid); max.reportValidity(); return;
        }
        const url = new URL(location.href);
        [min, max].forEach(input => input.value === '' ? url.searchParams.delete(input.name) : url.searchParams.set(input.name, input.value));
        url.searchParams.delete('page');
        if (!url.searchParams.has(minKey) && !url.searchParams.has(maxKey)) { location.assign(url); return; }
        history.pushState({}, '', url);
        this.apply();
      });
      this.querySelector('form').addEventListener('input', () => this.querySelector(`[name="${maxKey}"]`).setCustomValidity(''));
      this.querySelector('[data-joa-budget-clear]').addEventListener('click', () => {
        const url = new URL(location.href); url.searchParams.delete(minKey); url.searchParams.delete(maxKey); url.searchParams.delete('page'); location.assign(url);
      });
      this.apply();
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    async apply() {
      const ringFilters = this.closest("results-list")?.querySelector("joa-ring-filters");
      if (ringFilters) { await customElements.whenDefined("joa-ring-filters"); return ringFilters.apply(); }
      this.hidden = false;
      this.controller?.abort();
      const url = new URL(location.href), min = number(url.searchParams.get(minKey)), max = number(url.searchParams.get(maxKey));
      this.querySelector(`[name="${minKey}"]`).value = min === null ? '' : min / 100;
      this.querySelector(`[name="${maxKey}"]`).value = max === null ? '' : max / 100;
      if (min === null && max === null) return;
      const status = this.querySelector('[data-joa-budget-status]');
      status.setAttribute('role', 'status');
      if (min !== null && max !== null && min > max) { status.textContent = this.copy.invalid; return; }
      const host = this.closest('results-list'), grid = host?.querySelector('[data-testid="product-grid"]');
      if (!grid) { status.textContent = this.copy.empty; return; }
      const controller = new AbortController(); this.controller = controller;
      status.textContent = this.copy.loading; grid.setAttribute('aria-busy', 'true');
      const submit = this.querySelector('[type="submit"]'); submit.disabled = true;
      url.searchParams.delete('page'); url.searchParams.delete(minKey); url.searchParams.delete(maxKey); url.searchParams.set('section_id', 'joa-budget-products');
      const matches = [], ids = new Set(), visited = new Set();
      let next = url;
      try {
        while (next) {
          if (visited.has(next.href)) throw new Error('Repeated page');
          visited.add(next.href);
          const response = await fetch(next, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = doc.querySelector('[data-joa-budget-results]');
          if (!results) throw new Error('Results unavailable');
          results.querySelectorAll('[data-joa-budget-product]').forEach(card => {
            const price = Number(card.dataset.price);
            if (!Number.isFinite(price) || ids.has(card.dataset.productId)) return;
            ids.add(card.dataset.productId);
            if ((min === null || price >= min) && (max === null || price <= max)) matches.push(card);
          });
          next = results.dataset.next ? new URL(results.dataset.next, location.origin) : null;
          if (next) { if (next.origin !== location.origin) throw new Error('Invalid next page'); next.searchParams.set('section_id', 'joa-budget-products'); }
        }
        if (controller.signal.aborted || !this.isConnected || grid !== host.querySelector('[data-testid="product-grid"]')) return;
        host.infinityScrollObserver?.disconnect();
        host.pages?.clear();
        grid.dataset.lastPage = '1';
        grid.replaceChildren(...matches);
        host.classList.add('joa-budget-active');
        host.querySelectorAll('.pagination,[ref="viewMoreNext"],[ref="viewMorePrevious"]').forEach(node => { node.hidden = true; });
        status.textContent = matches.length ? this.copy.count.replace('__COUNT__', matches.length) : this.copy.empty;
        document.dispatchEvent(new Event('joa:saved-refresh'));
      } catch (error) {
        if (error.name !== 'AbortError') { status.textContent = this.copy.error; status.setAttribute('role', 'alert'); }
      } finally {
        if (this.controller === controller) { grid.removeAttribute('aria-busy'); submit.disabled = false; }
      }
    }
  }
  if (!customElements.get('joa-budget-filter')) customElements.define('joa-budget-filter', JoaBudgetFilter);
  document.addEventListener('shopify:collection:update', async event => {
    try { await event.detail?.promise; await event.promise; } catch { return; }
    requestAnimationFrame(() => document.querySelector('joa-budget-filter')?.apply());
  });
  window.addEventListener('popstate', () => location.reload());
})();
